import React from 'react'
import { resolveComponentForOperator } from 'components/ContactFilterBuilder/constants/PropertyComponents'

const NotBetween = ({ property, onChange }) => {
  const PropertyComponent = resolveComponentForOperator(property.type, 'NOT_BETWEEN')

  return (
    <div>
      <PropertyComponent
        property={property}
        onChange={onChange}
        isOperator={true}
      />
    </div>
  )
}

export default NotBetween
